import template from './hueb-seo-category-tree.html.twig';

const { Component } = Shopware;

Component.extend('hueb-seo-category-tree', 'sw-category-tree', {
    template,

    computed: {
        category() {},
    },

    methods: {
        checkItem(item) {
            this.$emit('check-item', item);
        },
        clickItem(item) {
            this.$emit('click-item', item);
        },
        changeCategory(category) {}
    }

});
